import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlParams } from 'hooks/use-url-params';
import { WimOperationalQualityI } from 'store/wim/types/platforms';
import { Loader, TableContainerWithSorting } from 'components';
import { ComponentFilterProps, withFilter } from 'hoc/withFilter';
import { WimOperationalQualityFilterValues } from 'store/wim/types/transits';

import { wimActions } from 'store/wim/slices';
import { queryParamsToFilterValues } from 'pages/Transits/TransitsFilterPanel/schema';
import { getWimOperationalQuality } from 'store/wim/wim-operational-quality/selectors';
import { INITIAL_TRANSITS_FILTER_VALUES } from 'store/wim/filter/transits';
import { RootState } from 'store/root-reducer';
import { useHeaderWithFiltersRenderer } from 'components/HeaderFilter';
import WimOperationalQualityFilter from './WimOperationalQualityFilter';
import { addRowSpan } from './WimOperationalQualityFilter/helpers/add-row-span';
import { getWimOperationalQualityColumns } from './table-schema';
import { StyledWimOperationalQualityWrapper } from './styles';

const WimOperationalQualityPage: FC<ComponentFilterProps<WimOperationalQualityFilterValues>> = ({ filterManager }) => {
  const { queryUrlParams } = useUrlParams({});
  const [currentParams, setCurrentParams] = useState(queryUrlParams.filter);

  const dispatch = useDispatch();
  const { state } = filterManager;
  const columns = Object.values(getWimOperationalQualityColumns());

  const { wimOperationalQuality, isLoading } = useSelector((wimOperationalQualityState) =>
    getWimOperationalQuality(wimOperationalQualityState as RootState)
  );

  useHeaderWithFiltersRenderer({ filterManager });
  useEffect(() => {
    dispatch(wimActions.wimOperationalQuality.requestWimOperationalQuality(currentParams || state));
  }, [dispatch, currentParams]);
  useEffect(() => {
    setCurrentParams(queryUrlParams.filter);
  }, [queryUrlParams]);

  return (
    <StyledWimOperationalQualityWrapper>
      <TableContainerWithSorting<WimOperationalQualityI>
        size="small"
        columns={columns}
        loading={isLoading}
        showSorterTooltip={false}
        dataSource={addRowSpan(wimOperationalQuality || [], 'wim')}
        rowClassName={(record) => `wim-operational-quality-row-${record.lane}`}
        className="wim-operational-quality"
        scroll={{ y: 'calc(100vh - 220px)' }}
      />
    </StyledWimOperationalQualityWrapper>
  );
};

export default withFilter<WimOperationalQualityFilterValues>({
  filterProps: {
    initialState: INITIAL_TRANSITS_FILTER_VALUES,
    formatUrlParams: queryParamsToFilterValues,
  },
  FilterContent: WimOperationalQualityFilter,
})(WimOperationalQualityPage);
